// extracted by mini-css-extract-plugin
export default {"productGallery":"PK-z","inQuickShop":"QK-z"};